import Vuex from 'vuex'
import Vue from 'vue'
import swal from 'sweetalert2'
import axios from 'axios'

import user from './store/modules/user'
import booking from './store/modules/booking'
import revocation from './store/modules/revocation'
import modify from './store/modules/modify'

import { set, yyyymmdd_ddmmyyy } from '@/utils'

import { API_ENDPOINT_BASE } from '@/constans'
import {
  LOADING,
  DEPARTURES,
  ASSIGNMENTS,
  AGENCIES,
  RESERVATIONS,
  PREVIEWS,
  FINANCING
} from '@/store/mutations'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    user,
    booking,
    revocation,
    modify
  },
  state: {
    loading: false,
    departures: [],
    agencies: [],
    previews: [],
    financing: [],
    assignments: []
  },
  mutations: {
    [LOADING]: set('loading'),
    [DEPARTURES]: set('departures'),
    [RESERVATIONS]: set('reservations'),
    [ASSIGNMENTS]: set('assignments'),
    [AGENCIES]: set('agencies'),
    [PREVIEWS]: set('previews'),
    [FINANCING]: set('financing')
  },
  actions: {
    DEPARTURE ({ dispatch, state, commit }, id) {
      commit(LOADING, true)
      return new Promise((resolve, reject) => {
        dispatch('booking/RESET')
        axios
          .get(API_ENDPOINT_BASE + '/departures/' + id)
          .then(({ data }) => {
            let departures = state.departures
            data.date_departure = yyyymmdd_ddmmyyy(data.date_departure)

            if (state.departures.some(departure => departure.id == id)) {
              departures = departures.map(departure =>
                departure.id == id ? Object.assign({}, departure, data) : departure
              )
            } else {
              departures.push(data)
            }

            commit(DEPARTURES, departures)
            resolve()
          })
          .catch(error => {
            swal({ html: error.response.data.msg, type: 'error' })
            reject()
          })
          .finally(() => commit(LOADING, false))
      })
    }
  }
})
